var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wen-xin-container" }, [
      _c("i", { staticClass: "el-icon-s-opportunity" }),
      _c("p", [
        _vm._v(" 温馨提示："),
        _c("span", { staticClass: "tips" }, [_vm._v("*")]),
        _vm._v(" 为必填项，信息填写越完善，越有助于用户提高购买几率")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }